import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTenants } from '../hooks/api';
import { Loading, ErrorBox, EmptyBox } from '../components/Loading';
import { Status } from '../components/Status';
import { formatTimestamp } from '../api';

export default function TenantsListPage() {
  const tenants = useTenants();
  const [filter, setFilter] = useState('');

  const filtered = (tenants.data?.data ?? []).filter((t) => {
    if (!filter) return true;
    const f = filter.toLowerCase();
    return t.code.toLowerCase().includes(f) || t.name.toLowerCase().includes(f);
  });

  return (
    <div className="space-y-3">
      <h1 className="text-[14px] font-semibold uppercase tracking-wide text-neutral-700 border-b border-neutral-300 pb-1">
        Tenants
      </h1>

      <div className="panel">
        <div className="panel-h flex items-center justify-between">
          <span>Suche</span>
          <span className="font-mono text-[10px] text-neutral-500">
            {filtered.length} / {tenants.data?.data.length ?? 0}
          </span>
        </div>
        <div className="panel-b">
          <input
            type="text"
            className="input w-full"
            placeholder="Tenant-Code oder Name..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>
      </div>

      <div className="panel">
        <div className="panel-h">Liste</div>
        <div className="panel-b p-0">
          {tenants.isLoading && (
            <div className="p-3">
              <Loading />
            </div>
          )}
          {tenants.error && (
            <div className="p-3">
              <ErrorBox error={tenants.error} />
            </div>
          )}
          {tenants.data && filtered.length === 0 && (
            <div className="p-3">
              <EmptyBox>Keine Treffer.</EmptyBox>
            </div>
          )}
          {filtered.length > 0 && (
            <table className="tbl">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Datenbank</th>
                  <th>Status</th>
                  <th>Angelegt</th>
                  <th>Aktualisiert</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((t) => (
                  <tr key={t.id}>
                    <td className="mono">{t.code}</td>
                    <td>{t.name}</td>
                    <td className="mono">{t.database_name}</td>
                    <td>
                      {t.active ? (
                        <Status kind="ok">aktiv</Status>
                      ) : (
                        <Status kind="muted">inaktiv</Status>
                      )}
                    </td>
                    <td className="mono">{formatTimestamp(t.created_at)}</td>
                    <td className="mono">{formatTimestamp(t.updated_at)}</td>
                    <td>
                      <Link
                        to={`/tenants/${encodeURIComponent(t.code)}`}
                        className="btn"
                      >
                        Detail
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
